import secureRandom from 'secure-random'
import CryptoJS from 'crypto-js'
import { JSEncrypt } from 'jsencrypt'
import * as keys from '../keys/keys'

export class ISecure{
	constructor(data) {
		this.public_key = keys.PUBLIC_KEY
		this.json_data  = data  
		this.encryptedData = {}
		this.rkey = ''
	    this.rIV  = ''
	    this.jsEncrypt = new JSEncrypt();
	}
	getEncryptData(){
	    var ivBytes   = secureRandom(16);
	    var keyBytes  = secureRandom(32);
	    var rkeyBytes = secureRandom(32);

	    var hexIV     = this.toHexString(ivBytes);
	    var hexKey    = this.toHexString(keyBytes);
	    var hexRKey   = this.toHexString(rkeyBytes);

	    var ivBase64   = btoa(hexIV);
	    var keyBase64  = btoa(hexKey);
	    var rkeyBase64 = btoa(hexRKey);

	    var data = this.encryptData(this.json_data,  hexKey, hexIV);
	    var hash = CryptoJS.MD5(this.json_data);
	    var strVerify = hash.toString(CryptoJS.enc.Base64);   
	    var strSecret = ivBase64+"|"+keyBase64+"|"+rkeyBase64;

	    strVerify = this.encryptWithPublicKey(strVerify, this.public_key);
	    strSecret = this.encryptWithPublicKey(strSecret, this.public_key);
	    
	    var params = {};
	    
	    params["stringSecret"] = strSecret;
	    params["stringVerify"] = strVerify;
	    params["stringData"]   = data;

	    this.encryptedData = params
	    this.rkey = rkeyBase64
	    this.rIV  = ivBase64

	    return JSON.stringify(params)
	}
	getDecryptData(data){
		let rkey = atob(this.rkey)
		let iv  = atob(this.rIV)
	  	return this.decryptData(data, rkey, iv);
	}
	encryptData(string, key_data, iv_data){
		// convert to hex
		var key = CryptoJS.enc.Hex.parse(key_data);
	    var iv  = CryptoJS.enc.Hex.parse(iv_data);

	    key = CryptoJS.SHA256(key)

	    var encrypted = CryptoJS.AES.encrypt(string, key, { iv: iv });
	    return encrypted.ciphertext.toString(CryptoJS.enc.Base64); 
	}
	decryptData(data, key_data, iv_data){
		// convert to hex
	 	var key = CryptoJS.enc.Hex.parse(key_data)
	    var iv  = CryptoJS.enc.Hex.parse(iv_data)

		key = CryptoJS.SHA256(key)
		let decrypted = {}
		
		decrypted  = CryptoJS.AES.decrypt(data, key , {iv : iv});
		
	    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
	}
	encryptWithPublicKey(data, public_key){
	    // Encrypt with the public key...
	      this.jsEncrypt.setPublicKey(public_key);
	      var encrypted = this.jsEncrypt.encrypt(data);
	      return encrypted;
	}
	toHexString(byteArray){
		return Array.from(byteArray, function(byte) {
    		return ('0' + (byte & 0xFF).toString(16)).slice(-2);
  		}).join('');
	}

}


// WEBPACK FOOTER //
// ./resources/assets/js/helpers/ISecure.js